<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="where" style="font-weight: bold;" label-width="77px" class="ele-form-search"
        @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="小组名称">
              <el-select v-model="where.id" multiple clearable filterable reserve-keyword
                :filter-method="handleClassFilter" class="ele-block" placeholder="请选择" @change="handleClassChange"
                @clear="resetClassSelectFilter">
                <el-option v-if="classFilterKeyword" :value="allFilteredSelectValue"
                  :label="`全选搜索结果（${filteredClassList.length}）`" />
                <el-option v-for="item in filteredClassList" :key="item.id" :value="item.id" :label="item.classname" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="收款信息">
              <el-select clearable filterable allow-create class="ele-block" v-model.trim="where.account_name"
                placeholder="请选择">
                <el-option v-for="item in account_name" :key="item.id" :value="item.id"
                  :label="item.account_name_value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="7" :md="12">
            <el-form-item label="选择时间">
              <el-date-picker v-model.trim="where.time" type="daterange" range-separator="至" start-placeholder="开始日期"
                value-format="yyyy-MM-dd" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload"><b>查询</b>
              </el-button>
              <el-button @click="reset"><b>重置</b></el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 315px)">
        <!-- 表头工具栏 -->
        <template slot="toolbar">
          <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon"
            @click="openEdit(null)"><b>添加</b>
          </el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" class="ele-btn-icon"
            @click="removeBatch"><b>删除</b>
          </el-button>
        </template>
        <!-- 操作列 -->
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" :underline="false" @click="openEdit(row)">
            <b>修改</b>
          </el-button>
          <el-button size="small" type="primary" class="ele-btn-icon" :underline="false" @click="openEdit2(row)">
            <b>校准</b>
          </el-button>
          <el-popconfirm class="ele-action" title="确定要删除此银行卡吗？" @confirm="remove(row)">
            <el-button size="small" type="danger" class="ele-btn-icon" :underline="false" slot="reference">
              <b>删除</b>
            </el-button>
          </el-popconfirm>
        </template>

        <!-- 状态列 -->
        <template slot="status" slot-scope="{ row }">
          <span @click="toggleStatus(row)" :style="{
            cursor: 'pointer',
            color: row.status === 1 ? '#67C23A' : '#F56C6C',
            fontWeight: 'bold'
          }">
            {{ row.status === 1 ? '正常' : '冻结' }}
          </span>
        </template>

        <!-- 状态列 -->
        <template slot="status_up" slot-scope="{ row }">
          <span @click="toggleStatusUp(row)" :style="{
            cursor: 'pointer',
            color: row.status_up === 1 ? '#67C23A' : '#909399',
            fontWeight: 'bold'
          }">
            {{ row.status_up === 1 ? '上线' : '下线' }}
          </span>
        </template>

        <!-- 状态列 -->
        <template slot="is_dk" slot-scope="{ row }">
          <span @click="toggleIsdk(row)" :style="{
            cursor: 'pointer',
            color: row.is_dk === 2 ? '#67C23A' : '#F56C6C',
            fontWeight: 'bold'
          }">
            {{ row.is_dk === 2 ? '开' : '关' }}
          </span>
        </template>
        <template slot="in_num" slot-scope="{ row }">
          <el-input v-model.number="row.in_num" size="mini" style="width: 100px" :min="0" placeholder="请输入"
            @blur="() => handleInNumChange(row)" @keyup.enter.native="() => handleInNumChange(row)">
            <template slot="append">笔</template>
          </el-input>
        </template>
      </ele-pro-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <recolumn-edit :data="current" :visible.sync="showEdit" @done="reload" />
    <!-- 编辑弹窗 -->
    <recolumn-edit-to :data="current2" :visible.sync="showEdit2" @done="reload" />

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RecolumnEdit from './recolumn-edit.vue';
import RecolumnEditTo from './recolumn-edit-to.vue';

export default {
  name: 'Resourcecolumn',
  components: { RecolumnEdit, RecolumnEditTo },
  computed: {
    ...mapGetters(["permission"]),
    filteredClassList() {
      const keyword = (this.classFilterKeyword || '').trim().toLowerCase();
      if (!keyword) {
        return this.classList;
      }
      return this.classList.filter(item =>
        String(item.classname || '').toLowerCase().includes(keyword)
      );
    }
  },
  data() {
    return {
      // 表格数据接口
      url: '/resourcecolumn/index',
      // 表格列配置
      columns: [
        {
          columnKey: 'selection',
          type: 'selection',
          width: 45,
          align: 'center',
          fixed: "left"
        },
        {
          prop: 'id',
          label: 'ID',
          width: 60,
          align: 'center',
          showOverflowTooltip: true,
          fixed: "left"
        },
        {
          prop: 'classname',
          label: '小组名称',
          showOverflowTooltip: true,
          minWidth: 100,
          align: 'center',
        },
        {
          prop: 'day_count',
          label: '今日收款',
          showOverflowTooltip: true,
          minWidth: 100,
          align: 'center',
        },
        {
          prop: 'sj_amount_to',
          label: '实际余额',
          showOverflowTooltip: true,
          minWidth: 100,
          align: 'center',
        },
        {
          prop: 'account_info',
          label: '收款信息',
          showOverflowTooltip: true,
          minWidth: 240,
          align: 'center',
          formatter: (row) => {
            const base = `${row.account_name} | ${row.bank_name} | ${row.account_number}`;
            return row.qr_code ? `${base} 码` : base;
          }
        },
        {
          prop: 'status_up',
          label: '在线状态',
          align: 'center',
          width: 100,
          resizable: false,
          slot: 'status_up',
        },
        {
          prop: 'status',
          label: '银行状态',
          align: 'center',
          width: 100,
          resizable: false,
          slot: 'status',
        },
        {
          prop: 'is_dk',
          label: '相同金额',
          align: 'center',
          width: 100,
          resizable: false,
          slot: 'is_dk',
        },
        {
          prop: 'fk_money',
          label: '风控上限',
          align: 'center',
          width: 100,
          resizable: false,
        },
        {
          prop: 'in_num',
          label: '收款笔数',
          align: 'center',
          width: 140,
          resizable: false,
          slot: 'in_num'
        },
        {
          prop: 'in_money',
          label: '收款金额',
          align: 'center',
          width: 100,
          resizable: false,
        },
        {
          prop: 'create_time',
          label: '创建时间',
          sortable: 'custom',
          showOverflowTooltip: true,
          minWidth: 160,
          align: 'center',
          formatter: (row, column, cellValue) => {
            return this.$util.toDateString(cellValue);
          }
        },
        {
          prop: 'update_time',
          label: '更新时间',
          sortable: 'custom',
          showOverflowTooltip: true,
          minWidth: 160,
          align: 'center',
          formatter: (row, column, cellValue) => {
            return this.$util.toDateString(cellValue);
          }
        },
        {
          columnKey: 'action',
          label: '操作',
          width: 200,
          align: 'center',
          resizable: false,
          slot: 'action',
          fixed: "right"
        }
      ],
      // 表格搜索条件，注意初始化为数组
      where: {
        id: [],
        account_name: '',
        time: ''
      },
      // 表格选中数据
      selection: [],
      account_name: [],
      classList: [],
      classFilterKeyword: '',
      allFilteredSelectValue: '__ALL_FILTERED__',
      // 当前编辑数据
      current: null,
      showEdit: false,
      current2: null,
      showEdit2: false
    };
  },
  mounted() {
    this.getResourceName();
    this.queryClass();
  },
  methods: {
    handleClassFilter(keyword) {
      this.classFilterKeyword = keyword || '';
    },
    resetClassSelectFilter() {
      this.classFilterKeyword = '';
    },
    handleClassChange(values) {
      if (!Array.isArray(values) || !values.includes(this.allFilteredSelectValue)) {
        return;
      }
      const filteredIds = this.filteredClassList.map(item => item.id);
      const currentIds = values.filter(id => id !== this.allFilteredSelectValue);
      this.where.id = Array.from(new Set([...currentIds, ...filteredIds]));
    },
    getSummary(param) {
      const { columns, data } = param;
      const sums = [];
      const sumColumns = ['今日收款'];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (sumColumns.indexOf(column.label) < 0) {
          sums[index] = '--';
          return;
        }
        const values = data.map(item => item[column.property]);
        sums[index] = values.reduce((total, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return Number(total) + Number(curr);
          } else {
            return Number(total);
          }
        }, 0);
        sums[index] = sums[index].toFixed(2);
      });
      return sums;
    },
    toggleStatusUp(row) {
      row.status_up = row.status_up === 1 ? 2 : 1;
      this.editStatusUp(row); // 保留原有逻辑
    },
    toggleStatus(row) {
      row.status = row.status === 1 ? 2 : 1;
      this.editStatus(row); // 调用已有方法提交修改
    },
    toggleIsdk(row) {
      row.is_dk = row.is_dk === 2 ? 1 : 2;
      this.editIsdk(row); // 保留原有逻辑
    },
    handleInNumChange(row) {
      if (row.in_num === '' || row.in_num === null || isNaN(row.in_num)) {
        row.in_num = 0;
      }
      const loading = this.$loading({ lock: true });
      this.$http
        .post('/Resourcecolumn/updateInNum', {
          id: row.id,
          in_num: row.in_num
        })
        .then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success('修改成功');
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
    },
    // ✅ 修复：多选 ID 处理为逗号分隔字符串
    reload() {
      const params = {
        ...this.where,
        id: Array.isArray(this.where.id) ? this.where.id.join(',') : this.where.id
      };
      this.$refs.table.reload({ where: params });
    },
    // ✅ 初始化下拉选项
    queryClass() {
      this.$http
        .get("/Resourceclass/getClassList")
        .then((res) => {
          if (res.data.code === 0) {
            this.classList = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    // ✅ 重置为初始数组
    reset() {
      this.where = {
        id: [],
        account_name: '',
        time: ''
      };
      this.reload();
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    openEdit2(row) {
      this.current2 = row;
      this.showEdit2 = true;
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/resourcecolumn/delete', { id: row.id }).then(res => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请至少选择一条数据');
        return;
      }
      this.$confirm('确定要删除选中的广告吗?', '提示', {
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/resourcecolumn/delete', { id: this.selection.map(d => d.id) }).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => { });
    },
    getResourceName() {
      this.$http.post('/resourcecolumn/getResourceName').then(res => {
        if (res.data.code === 0) {
          this.account_name = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    editIsdk(row) {
      const loading = this.$loading({ lock: true });
      const params = {
        id: row.id,
        is_dk: row.is_dk
      };
      this.$http.post('/resourcecolumn/isdk', params).then(res => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          row.status = !row.status ? 1 : 2;
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    editStatus(row) {
      const loading = this.$loading({ lock: true });
      const params = {
        id: row.id,
        status: row.status
      };
      this.$http.post('/resourcecolumn/status', params).then(res => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          row.status = !row.status ? 1 : 2;
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    editStatusUp(row) {
      const loading = this.$loading({ lock: true });
      const params = {
        id: row.id,
        status_up: row.status_up
      };
      this.$http.post('/resourcecolumn/statusup', params).then(res => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          row.status_up = !row.status_up ? 1 : 2;
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        loading.close();
        this.$message.error(e.message);
      });
    }
  }
}
</script>


<style scoped>
.el-table {
  .el-table__body-wrapper {
    z-index: 2;
  }
}

::-webkit-scrollbar {
  background: rgb(231, 230, 230);
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgb(231, 230, 230);
  width: 8px;
}
</style>
